import { useTheme } from '@emotion/react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import './TextField.css';

import { Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';
import invite from 'assets/images/invite.png';
import { API_URL, INVITE } from 'constant/app.config';
import { validateEmail } from 'utils/validation.util';
import { postApiCall } from 'api/apiService';
import Loading from 'assets/images/loading.png';
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1),
  },
  input: {
    '&:focus': {
      borderColor: 'black',
    },
  },
}));

function InvitePopup({
  openInvite,
  setOpenInvite,
  BrowsingPartner = false,
  fromleftmenu,
}) {
  const classes = useStyles();
  const [selectUserType, setSelectUserType] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = React.useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setSelectUserType(e.target.value);
    setSelectTypeError(false);
  };

  const [action, setAction] = useState('');
  const [newAction] = useState(false);
  const [lastSeenUser, setLastSeenUser] = useState('');
  const [activity, setActivity] = useState(false);
  const [menuicon, setMenuicon] = useState(false);

  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const userType = userDetail?.primaryUserType;
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('');
  const [ErrorMsg, setErrorMsg] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const [firstNameError, setFirstNameError] = useState(false);
  const [secondNameError, setSecondNameError] = useState(false);
  const [emailAddError, setEmailAddError] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [selectTypeError, setSelectTypeError] = useState(false);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xl'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches800 = useMediaQuery(theme.breakpoints.down(800));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));
  const matches390 = useMediaQuery(theme.breakpoints.down(390));
  const matches490 = useMediaQuery(theme.breakpoints.down(490));
  const matches430 = useMediaQuery(theme.breakpoints.down(430));
  const matches355 = useMediaQuery(theme.breakpoints.down(355));

  const InviteData = {
    mobileNo: mobile,
    email: email,
    userTypeCode: selectUserType,

    surName: lastName?.charAt(0).toUpperCase() + lastName?.slice(1)?.trim(),
    userName: firstName?.charAt(0).toUpperCase() + firstName?.slice(1)?.trim(),
  };

  const handleClose = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setMobile('');
    setSelectUserType('');
    setOpenInvite(!openInvite);
    setErrorMsg(false);
    setOpenAlert(false);
    setFirstNameError(false);
    setSecondNameError(false);
    setEmailError(false);
    setEmailAddError(false);
    setMobileNumberError(false);
    setSelectTypeError(false);
  };

  const ErrorSubmit = () => {
    const timeout = setTimeout(() => {
      if (!fromleftmenu) {
        setOpenInvite(!openInvite);
      }
      setOpenAlert(false);
      setFirstName('');
      setLastName('');
      setEmail('');
      setMobile('');
      setSelectUserType('');
      setErrorMsg(false);
    }, 2000); // 2 seconds

    return () => clearTimeout(timeout);
  };

  const handleSelect = async () => {
    setLoading(true);

    const accessToken = `Bearer ${localStorage.getItem('accesstoken')}`;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: accessToken,
    };

    try {
      const response = await postApiCall(INVITE, InviteData);

      const { status, data, message } = response?.data;

      if (status === 1) {
        setOpenAlert(true);
        setAlertMessage(message || 'Invitation sent successfully.');
        ErrorSubmit();
      } else if (status === -1) {
        setOpenAlert(true);
        setAlertMessage(message || 'An issue occurred.');
        setErrorMsg(true);
      } else {
        console.info('Unexpected status:', status);
      }
    } catch (error) {
      console.error('Error during API call:', error);
      setOpenAlert(true);
      setAlertMessage('An error occurred while sending the invite.');
    } finally {
      setLoading(false);
    }
  };
  const handleMobileChange = (event, index) => {
    const inputValue = event.target.value.replace(/\D/g, ''); // keep only digits
    let formattedValue = inputValue;

    // Format into 04XX XXX XXX
    formattedValue = formattedValue
      .replace(/^(\d{0,4})(\d{0,3})(\d{0,3})$/, (_, p1, p2, p3) =>
        [p1, p2, p3].filter(Boolean).join(' ')
      )
      .trim();

    let errorMessage = '';

    if (inputValue.length > 0 && !inputValue.startsWith('04')) {
      errorMessage = 'Mobile number format should be: 04XX XXX XXX';
    } else if (inputValue.length > 0 && inputValue.length !== 10) {
      errorMessage = 'Mobile number must have exactly 10 digits';
    } else if (
      formattedValue.length > 0 &&
      !/^04\d{2}\s?\d{3}\s?\d{3}$/.test(formattedValue)
    ) {
      errorMessage = 'Mobile number format: 04XX XXX XXX';
    }
    // Update state
    setMobile(formattedValue);
    setMobileNumberError(!!errorMessage);
    setError(errorMessage);
  };

  useEffect(() => {
    const successAlertTimeout = setTimeout(() => {
      setOpenSuccessAlert(false);
    }, 3000);

    const errorAlertTimeout = setTimeout(() => {
      setOpenErrorAlert(false);
    }, 3000);

    return () => {
      clearTimeout(successAlertTimeout);
      clearTimeout(errorAlertTimeout);
    };
  }, [openSuccessAlert, openErrorAlert]);

  const [open, setOpen] = useState(false);

  const Invertedmenu = () => {
    return (
      <svg
        width="21"
        height="5"
        viewBox="0 0 21 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1816 2.49996C12.1816 3.4303 11.4274 4.18449 10.497 4.18449C9.56669 4.18449 8.8125 3.4303 8.8125 2.49996C8.8125 1.56962 9.56669 0.81543 10.497 0.81543C11.4274 0.81543 12.1816 1.56962 12.1816 2.49996Z"
          fill="#666666"
        />
        <path
          d="M3.75968 2.49996C3.75968 3.4303 3.00549 4.18449 2.07515 4.18449C1.14481 4.18449 0.390625 3.4303 0.390625 2.49996C0.390625 1.56962 1.14481 0.81543 2.07515 0.81543C3.00549 0.81543 3.75968 1.56962 3.75968 2.49996Z"
          fill="#666666"
        />
        <path
          d="M20.6034 2.49996C20.6034 3.4303 19.8492 4.18449 18.9189 4.18449C17.9886 4.18449 17.2344 3.4303 17.2344 2.49996C17.2344 1.56962 17.9886 0.81543 18.9189 0.81543C19.8492 0.81543 20.6034 1.56962 20.6034 2.49996Z"
          fill="#666666"
        />
      </svg>
    );
  };
  const [isClicked, setIsClicked] = useState(false);

  const handleMouseEnter = () => {
    setIsClicked(true);
  };
  const handleMouseLeave = () => {
    setIsClicked(false);
  };
  const handleClick = () => {
    setIsClicked(true);
  };
  const [isChecked, setIsChecked] = useState(false);

  const handleMouseEnter1 = () => {
    setIsChecked(true);
  };
  const handleMouseLeave1 = () => {
    setIsChecked(false);
  };
  const handleCheck = () => {
    setIsChecked(true);
  };
  const [isMarked, setIsMarked] = useState(false);

  const handleMouseEnter2 = () => {
    setIsMarked(true);
  };
  const handleMouseLeave2 = () => {
    setIsMarked(false);
  };
  const handleMark = () => {
    setIsMarked(true);
  };
  const [isTicked, setIsTicked] = useState(false);

  const handleMouseEnter3 = () => {
    setIsTicked(true);
  };
  const handleMouseLeave3 = () => {
    setIsTicked(false);
  };
  const handleTick = () => {
    setIsTicked(true);
  };

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  const isFormValid =
    firstName.trim() !== '' &&
    lastName.trim() !== '' &&
    email.trim() !== '' &&
    !validateEmail(email) &&
    mobile.trim() !== '' &&
    !mobileNumberError &&
    selectUserType !== '';

  return (
    <Grid
      container
      style={{
        display: 'flex',
        justifyContent: menuicon ? 'right' : 'space-between',
        alignItems: 'flex-start',
      }}
      whiteSpace={'nowrap'}
    >
      <Modal
        open={openInvite}
        hideBackdrop
        disableEnforceFocus
        disableAutoFocus
        disableRestoreFocus
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pointerEvents: 'none',
        }}
      >
        <Box
          sx={{
            transform: 'scale(var(--app-scale))',
            pointerEvents: 'auto',
            width: 721,
            bgcolor: '#fff',
            borderRadius: '8px',
            p: 3,
            boxShadow: 24,
          }}
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              let hasError = false;
              if (firstName == '') {
                setFirstNameError(true);
                hasError = true;
              }
              if (lastName == '') {
                setSecondNameError(true);
                hasError = true;
              }
              if (email == '') {
                setEmailAddError(true);
                setEmailError(false);
                hasError = true;
              } else if (validateEmail(email)) {
                setEmailAddError(false);
                setEmailError(true);
                hasError = true;
              } else {
                setEmailAddError(false);
                setEmailError(false);
              }
              if (mobile == '') {
                setMobileNumberError(true);
                hasError = true;
              }

              if (selectUserType == '') {
                setSelectTypeError(true);
                hasError = true;
              }

              if (!hasError) {
                handleSelect();
              }
            }}
          >
            {openAlert ? (
              <>
                <Alert
                  severity={
                    alertMessage == 'Invitation Sent Successfully To The User'
                      ? 'success'
                      : 'error'
                  }
                  onClose={() => setOpenAlert(false)}
                  sx={{ fontFamily: 'poppins', fontWeight: 700 }}
                >
                  {alertMessage}
                </Alert>
              </>
            ) : (
              ''
            )}
            {openAlert && (
              <>
                <br></br>
              </>
            )}

            <Grid container>
              <Grid item container direction={'column'}>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '14px',
                      lineHeight: '21px',
                      color: '#666666',
                    }}
                  >
                    Invitation
                  </Typography>
                </Grid>
                <Grid
                  item
                  container
                  gap={matches490 ? 1 : 2}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: matches600 ? '-10px' : '20px',
                  }}
                >
                  <Grid item xs={1}>
                    <img
                      src={invite}
                      alt="invite"
                      style={{
                        width: matches430
                          ? '25px'
                          : matches490
                          ? '30px'
                          : '46px',
                        height: matches430
                          ? '25px'
                          : matches490
                          ? '30px'
                          : '46px',
                      }}
                    />
                  </Grid>
                  <Grid>
                    <Grid
                      item
                      marginTop={'10px'}
                      display={'flex'}
                      alignItems={'end'}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500 !important',
                          fontSize: matches355
                            ? '11px'
                            : matches390
                            ? '12px'
                            : matches430
                            ? '13px'
                            : matches490
                            ? '14px'
                            : matches600
                            ? '16px'
                            : matches700
                            ? '20px'
                            : '24px',
                          lineHeight: '36px',
                          color: '#000000',
                        }}
                      >
                        Would you like to invite someone to retreX?
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: matches355
                            ? '11px'
                            : matches390
                            ? '12px'
                            : matches430
                            ? '14px'
                            : matches490
                            ? '15px'
                            : '16px',
                          color: '#666666',
                          paddingLeft: '5px',
                        }}
                      >
                        Please enter their details below.
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  display={'flex'}
                  direction={'row'}
                  justifyContent={'space-between'}
                  marginTop={matches600 ? '10px' : '23px'}
                >
                  <Grid item xs={!matches600 ? 5.9 : 12}>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: matches600 ? '16px' : '18px',
                        fontWeight: 500,
                        color: '#333',
                        mb: 0.5,
                      }}
                    >
                      First Name
                      <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      sx={{
                        background: '#FFFFFF',
                        borderRadius: '5px',
                        textTransform: 'capitalize',
                        display: 'flex',
                        justifyContent: 'center',
                        '& .MuiInputBase-root': {
                          fontFamily: 'poppins',
                          height: matches600 ? '38px' : '48px',
                        },
                      }}
                      inputProps={{
                        maxLength: 25,
                        style: {
                          fontFamily: 'poppins',
                          textTransform: 'capitalize',
                          minHeight: '50px',
                          fontSize: matches600 ? '12px' : '',
                        },
                      }}
                      className={`my-text-field ${
                        isClicked ? 'highlighted' : ''
                      }`}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      onClick={handleClick}
                      placeholder="First Name"
                      error={firstNameError}
                      value={firstName}
                      onChange={(event) => {
                        const regex = /^[A-Za-z ]+$/;
                        if (
                          regex.test(event.target.value) ||
                          event.target.value === ''
                        ) {
                          setFirstName(event.target.value);
                          setFirstNameError(false);
                        }

                        setError(false);
                      }}
                      InputProps={{
                        disableUnderline: true,
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                    />
                    <span
                      style={{
                        visibility: firstNameError ? 'visible' : 'hidden',
                        color: '#d32f2f',
                        fontFamily: 'poppins',
                        fontSize: matches600 ? '10px' : '12px',
                      }}
                    >
                      Please enter your First name
                    </span>
                  </Grid>
                  <Grid item xs={!matches600 ? 5.9 : 12}>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: matches600 ? '16px' : '18px',
                        fontWeight: 500,
                        color: '#333',
                        mb: 0.5,
                      }}
                    >
                      Last Name
                      <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      sx={{
                        background: '#FFFFFF',
                        borderRadius: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                        '& .MuiInputBase-root': {
                          fontFamily: 'poppins',
                          height: matches600 ? '38px' : '48px',
                        },
                      }}
                      inputProps={{
                        maxLength: 25,
                        style: {
                          fontFamily: 'poppins',
                          textTransform: 'capitalize',
                          fontSize: matches600 ? '12px' : '',
                        },
                      }}
                      className={`my-text-field ${
                        isChecked ? 'highlighted1' : ''
                      }`}
                      onMouseEnter={handleMouseEnter1}
                      onMouseLeave={handleMouseLeave1}
                      onClick={handleCheck}
                      placeholder="Last Name"
                      error={secondNameError}
                      value={lastName}
                      onChange={(event) => {
                        const regex = /^[A-Za-z ]+$/;
                        if (
                          regex.test(event.target.value) ||
                          event.target.value === ''
                        ) {
                          setLastName(event.target.value);
                          setSecondNameError(false);
                        }
                        setError(false);
                      }}
                      InputProps={{
                        disableUnderline: true,
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                    />
                    <span
                      style={{
                        visibility: secondNameError ? 'visible' : 'hidden',
                        color: '#d32f2f',
                        fontFamily: 'poppins',
                        fontSize: matches600 ? '10px' : '12px',
                      }}
                    >
                      Please enter your Last name
                    </span>
                  </Grid>
                </Grid>
                <Grid
                  container
                  display={'flex'}
                  direction={'row'}
                  justifyContent={'space-between'}
                  marginTop={!matches600 && '10px'}
                >
                  <Grid item xs={!matches600 ? 5.9 : 12}>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: matches600 ? '16px' : '18px',
                        fontWeight: 500,
                        color: '#333',
                        mb: 0.5,
                      }}
                    >
                      Email <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      error={emailAddError}
                      sx={{
                        background: '#FFFFFF',
                        borderRadius: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                        '& .MuiInputBase-root': {
                          fontFamily: 'poppins',
                          height: matches600 ? '38px' : '48px',
                        },
                      }}
                      className={`my-text-field ${
                        isMarked ? 'highlighted1' : ''
                      }`}
                      onMouseEnter={handleMouseEnter2}
                      onMouseLeave={handleMouseLeave2}
                      onClick={handleMark}
                      placeholder="Enter Email"
                      value={email}
                      onChange={(event) => {
                        const value = event.target.value.toLowerCase();
                        setEmail(value);
                        if (value == '') {
                          setEmailAddError(true);
                          setEmailError(false);
                        } else if (validateEmail(value)) {
                          setEmailAddError(false);
                          setEmailError(true);
                        } else {
                          setEmailAddError(false);
                          setEmailError(false);
                        }

                        setError(false);
                      }}
                      InputProps={{
                        style: {
                          fontFamily: 'poppins',
                          fontSize: matches600 ? '12px' : '',
                        },
                        disableUnderline: true,
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                    />
                    <span
                      style={{
                        visibility:
                          emailAddError || emailError ? 'visible' : 'hidden',
                        color: '#d32f2f',
                        fontFamily: 'poppins',
                        fontSize: matches600 ? '10px' : '12px',
                      }}
                    >
                      {emailError
                        ? 'Please enter valid Email address'
                        : emailAddError && 'Please enter valid Email address'}
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={!matches600 ? 5.9 : 12}
                    sx={{ marginTop: matches600 && '15px' }}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: matches600 ? '16px' : '18px',
                        fontWeight: 500,
                        color: '#333',
                        mb: 0.5,
                      }}
                    >
                      Mobile
                      <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      name="mobile"
                      error={mobileNumberError}
                      sx={{
                        background: '#FFFFFF',
                        borderRadius: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                        '& .MuiInputBase-root': {
                          fontFamily: 'poppins',
                          height: matches600 ? '38px' : '48px',
                          paddingLeft: '10px',
                        },
                      }}
                      className={`my-text-field ${
                        isTicked ? 'highlighted1' : ''
                      }`}
                      onMouseEnter={handleMouseEnter3}
                      onMouseLeave={handleMouseLeave3}
                      onClick={handleTick}
                      placeholder="Mobile Number"
                      value={mobile}
                      onChange={(event) => {
                        handleMobileChange(event);
                        if (mobile != '') {
                          setMobileNumberError(false);
                        }
                      }}
                      inputProps={{
                        style: {
                          fontFamily: 'poppins',
                          textTransform: 'capitalize',
                          fontSize: matches600 ? '12px' : '',
                        },
                        maxLength: 12,
                        minLength: 12,
                        disableUnderline: true,
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                    />
                    {
                      <span
                        style={{
                          visibility:
                            error || mobileNumberError ? 'visible' : 'hidden',
                          color: '#d32f2f',
                          fontFamily: 'poppins',
                          fontSize: matches600 ? '10px' : '12px',
                        }}
                      >
                        {error ? error : 'Please enter your mobile number'}
                      </span>
                    }
                  </Grid>
                </Grid>
                <Grid
                  container
                  display={'flex'}
                  direction={'column'}
                  marginTop={!matches600 && '10px'}
                >
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: matches600 ? '16px' : '18px',
                        fontWeight: 500,
                        color: '#333',
                        mb: 0.5,
                      }}
                    >
                      User Type
                      <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <FormControl
                      className={classes.formControl}
                      sx={{
                        borderRadius: '5px',
                        width: '100%',
                        margin: '0px !important',
                      }}
                    >
                      <Select
                        disableUnderline
                        error={selectTypeError}
                        IconComponent={ExpandMoreIcon}
                        onChange={handleChange}
                        sx={{
                          'MuiFormControl-root': {
                            margin: '0px !important',
                          },
                          margin: '0px !important',
                          fontFamily: 'Poppins',
                          fontStyle: 'normal !important',
                          fontWeight: '300 !important',
                          fontSize: matches600 ? '12px' : '16px',
                          height: matches600 ? '38px' : '48px',
                          alignItems: 'center',
                          paddingLeft: '9px',
                          width: '100%',
                        }}
                        value={selectUserType}
                        displayEmpty
                        renderValue={(value) => {
                          switch (value) {
                            case '':
                              return (
                                <span
                                  style={{
                                    color: '#aaa',
                                    fontFamily: 'Poppins ',
                                    fontWeight: '200',
                                    fontSize: matches600 ? '12px' : '16px',
                                    minHeight: matches600 ? '0px' : '',
                                  }}
                                >
                                  Select User Type
                                </span>
                              );
                            case 'Buyer001':
                              return 'Buyer';
                            case 'Agent001':
                              return 'Agent';
                            case 'Vendor001':
                              return 'Vendor';
                            default:
                              return value;
                          }
                        }}
                      >
                        <MenuItem
                          value="Buyer001"
                          disabled={userType === 'Vendor'}
                          sx={{
                            fontFamily: 'Poppins ',
                            fontWeight: '300',
                            fontSize: matches600 ? '12px' : '16px',
                            minHeight: matches600 ? '0px' : '',
                          }}
                        >
                          Buyer
                        </MenuItem>
                        <MenuItem
                          value="Agent001"
                          disabled={BrowsingPartner}
                          sx={{
                            fontFamily: 'Poppins ',
                            fontWeight: '300',
                            fontSize: matches600 ? '12px' : '16px',
                            minHeight: matches600 ? '0px' : '',
                          }}
                        >
                          Agent
                        </MenuItem>
                        <MenuItem
                          value="Vendor001"
                          disabled={userType === 'Buyer' || BrowsingPartner}
                          sx={{
                            fontFamily: 'Poppins',
                            fontWeight: '300',
                            fontSize: matches600 ? '12px' : '16px',
                            minHeight: matches600 ? '0px' : '',
                          }}
                        >
                          Vendor
                        </MenuItem>
                      </Select>
                      <span
                        style={{
                          visibility: selectTypeError ? 'visible' : 'hidden',
                          color: '#d32f2f',
                          fontFamily: 'poppins',
                          fontSize: matches600 ? '10px' : '12px',
                          padding: '',
                          marginTop: '5px',
                        }}
                      >
                        Please choose an option
                      </span>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                gap={2}
                marginTop={matches600 && 1}
                sx={{ mt: 3 }}
              >
                {!fromleftmenu && (
                  <Grid item>
                    <Button
                      disabled={loading}
                      variant="outlined"
                      style={{
                        padding: loading
                          ? '10px 24px'
                          : matches390
                          ? '10px 33px'
                          : '10px 43px',
                        width: '100%',
                        height: '41px',
                        fontSize: '14px',
                        color: '#666666',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        border: '1px solid rgba(17, 35, 71, 0.1)',
                        borderRadius: '5px',
                        textTransform: 'none',
                      }}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Grid>
                )}
                <Grid item>
                  <Button
                    variant="outlined"
                    type="submit"
                    style={{
                      padding: loading
                        ? '10px 24px'
                        : matches390
                        ? '10px 33px'
                        : '10px 39px',
                      width: '100%',
                      height: '41px',
                      fontSize: '14px',
                      color: '#FFFFFF',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      background: isFormValid ? '#4ca4d6' : '#BDBDBD',
                      borderRadius: '5px',
                      textTransform: 'none',
                    }}
                    disabled={loading || !isFormValid}
                  >
                    Confirm
                  </Button>
                </Grid>
                {loading && (
                  <Grid item sx={{ marginTop: '4px' }}>
                    <img
                      alt="Loader"
                      src={Loading}
                      className="loaderImage"
                      style={{ height: '40px', width: '40px' }}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </Grid>
  );
}
export default InvitePopup;
